const FULL_PANEL_EMAILS = new Set([
  'samirgoel3@gmail.com',
  'carplay4@gmail.com',
]);

export function normalizePanelEmail(value: string | null | undefined): string {
  return (value ?? '').trim().toLowerCase();
}

export function hasFullPanelAccess(
  user: { userEmail?: string | null; googleMail?: string | null } | null | undefined
): boolean {
  if (!user) {
    return false;
  }
  return [user.userEmail, user.googleMail].some((email) =>
    FULL_PANEL_EMAILS.has(normalizePanelEmail(email))
  );
}
